import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'SSBISocialAcceptance',
    label: 'SSBISocialAcceptance',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
